<template>
  <div class="error-page container">
    <div class="error-page__wrapper">
      <div class="error-page__header">
        <slot name="heading" />
      </div>
      <div class="error-page__image">
        <slot name="image" />
      </div>
      <div class="error-page__details">
        <slot name="details" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ErrorPageLayout',
}
</script>

<style scoped>
.error-page.container {
  padding: 60px 20px 0;
}

.error-page__wrapper {
  text-align: center;
}

.error-page img {
  width: 100%;
  max-width: 450px;
}

.error-page__details {
  margin-top: 30px;
}

.error-page__image {
  margin-top: 20px;
}
</style>
